import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import { useAuthContext } from '../../common/ProtectedLayout';
import DaumPostcode from 'react-daum-postcode';

function Staff(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const [staffList, setStaffList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const [staffinfo, setStaffInfo] = useState([]);
    const [reserveCount, setReserveCount] = useState([]);
    const modalCorrective = useRef(); // 등록 모달 ref

    const [staffToDelete, setStaffToDelete] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState(''); // 검색어 상태
    const [addressModalOpen, setAddressModalOpen] = useState(false);
    const addressModalRef = useRef();

    const getStaffRegist = async () => {
        try {
            const getPage = (page - 1) * 10;
            const params = searchQuery.trim() !== '' ? { query: searchQuery } : {};
            const staff_result = await axios.get(`/StaffRegist/${getPage}`, { params });
            setStaffList(staff_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };
    const getReserveCount = async () => {
        try {
            const reserve_result = await axios.get('/StaffCount');
            setReserveCount(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    useEffect(() => {
        getStaffRegist();
    }, [page])

    useEffect(() => {
        setIsValidAccess(true);
        getStaffRegist();
        getReserveCount();
    }, [location.state, navigate]);

    useEffect(() => {
        if (addressModalOpen) {
            addressModalRef.current?.showModal();
        } else {
            addressModalRef.current?.close();
        }
    }, [addressModalOpen]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    const putCorrective = async () => {
        const requiredFields = [
            { key: 'id', label: '아이디' },
            { key: 'name', label: '이름' },
            { key: 'english_name', label: '영문이름' },
            { key: 'phone_num', label: '연락처' },
            { key: 'address', label: '주소' },
            { key: 'resident_number', label: '주민등록번호' },
            { key: 'regist_date', label: '입사일' },
            { key: 'affili', label: '소속' },
        ];
        for (const { key, label } of requiredFields) {
            if (!staffinfo[key]?.trim()) {
                alert(`${label}을(를) 입력해주세요`);
                return;
            }
        }
        const requestData = {
            id: staffinfo.id || "",
            pw: staffinfo.pw || "1111",
            name: staffinfo.name || "",
            english_name: staffinfo.english_name || "",
            phone_num: staffinfo.phone_num || "000-0000-0000",
            address: staffinfo.address || "",
            resident_number: staffinfo.resident_number || "",
            regist_date: staffinfo.regist_date || "",
            rank: staffinfo.rank || "사원",
            affili: staffinfo.affili || ""
        };
        try {
            const result = await axios.post('/StaffRegist', requestData);
            alert(result.data.message);
            modalCorrective.current.close();
            getStaffRegist();
        } catch (error) {
            console.error('Error :', error.message);
        }
    }

    const ChangeId = (e) => {
        let input = e.target.value.replace(/[^a-zA-Z0-9\s]/g, ''); // 영어와 숫자 허용
        setStaffInfo({ ...staffinfo, id: input });
    }
    const ChangePw = (e) => {
        setStaffInfo({ ...staffinfo, pw: e.target.value });
    }
    const ChangeName = (e) => {
        setStaffInfo({ ...staffinfo, name: e.target.value });
    }
    const ChangeEnName = (e) => {
        let input = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // 영어와 공백만 허용
        setStaffInfo({ ...staffinfo, english_name: input });
    }
    const ChangePhoneNum = (e) => {
        let input = e.target.value.replace(/[^0-9]/g, ''); // 숫자가 아닌 모든 문자 제거

        if (input.length > 11) {
            input = input.slice(0, 11); // 길이 제한
        }

        // 자동 포맷팅
        if (input.length < 4) {
            input = input;
        } else if (input.length < 8) {
            input = input.slice(0, 3) + '-' + input.slice(3);
        } else {
            input = input.slice(0, 3) + '-' + input.slice(3, 7) + '-' + input.slice(7);
        }

        setStaffInfo({ ...staffinfo, phone_num: input });
    }
    const ChangeRank = (e) => {
        setStaffInfo({ ...staffinfo, rank: e.target.value });
    }
    const ChangeAddress = (e) => {
        setStaffInfo({ ...staffinfo, address: e.target.value });
    }
    const ChangeResident = (e) => {
        let input = e.target.value.replace(/\D/g, ''); // 숫자만 허용

        if (input.length > 6) {
            input = input.slice(0, 6) + '-' + input.slice(6, 13);
        }

        if (input.length > 14) { // 최대 길이 제한
            input = input.slice(0, 14);
        }
        setStaffInfo({ ...staffinfo, resident_number: input });
    }
    const ChangeDate = (e) => {
        setStaffInfo({ ...staffinfo, regist_date: e.target.value });
    }
    const ChangeAffliation = (e) => {
        setStaffInfo({ ...staffinfo, affili: e.target.value });
    }

    const handleAddressComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';
        if (data.addressType === 'R') {
            if (data.bname !== '') extraAddress += data.bname;
            if (data.buildingName !== '') extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        setStaffInfo({ ...staffinfo, address: fullAddress });
        setAddressModalOpen(false);
    };

    const startCorrective = () => {
        modalCorrective.current.showModal();
    }

    const openDeleteDialog = (staff) => {
        setStaffToDelete(staff);
        setIsDeleteModalOpen(true);
    };
    const closeDeleteDialog = () => {
        setIsDeleteModalOpen(false);
        setStaffToDelete(null);
    };

    const confirmDeleteStaff = async () => {
        try {
            const result = await axios.delete(`/StaffRegist/${staffToDelete.id}`);
            alert(result.data.message);
            getStaffRegist();
            closeDeleteDialog();
        } catch (error) {
            console.error('Error deleting staff:', error.message);
            closeDeleteDialog();
        }
    };

    // 검색 핸들러
    const handleSearch = () => {
        setPage(1);
        getStaffRegist();
    };

    // Enter 키 핸들러
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="dashboard-container">
            <div className="content-container">
                {/* 검색 UI - 나중에 사용하기 위해 주석처리 */}
                {/* <SearchContainer>
                    <SearchInput
                        type="text"
                        placeholder="아이디, 이름, 연락처, 가입일자로 검색..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <SearchButton onClick={handleSearch}>검색</SearchButton>
                </SearchContainer> */}
                <div style={{ marginTop: '50px' }}>
                    <CommonTable headerTitle={['No', '아이디', '연락처', '주소', '주민등록번호', '입사일자', 'CS등급', '소속']}>
                        {
                            staffList.map((reserve, index) => {
                                return (
                                    <CommonTableRow key={index} idx={reserve.idx} beforePage={'/staff'} kind={'staff'}>
                                        <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.id}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.phone_num}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.address}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.resident_number}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.regist_date}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.rank}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.affili}</CommonTableColumn>

                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>
                {/* Manager.js 스타일의 버튼 적용 */}
                <ButtonContainer>
                    <PrimaryButton onClick={startCorrective}>CS등록</PrimaryButton>
                </ButtonContainer>

                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={reserveCount}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>

            {/* Manager.js 스타일의 모달 적용 */}
            <StyledDialog ref={modalCorrective} style={{ width: '800px' }}>
                <DialogHeader>
                    <h3>CS 매니저 등록</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>아이디</Label>
                            <StyledInput value={staffinfo.id || ''} onChange={ChangeId} />
                        </InputGroup>
                        <InputGroup>
                            <Label>비밀번호</Label>
                            <StyledInput type="password" value={staffinfo.pw || ''} onChange={ChangePw} />
                        </InputGroup>
                        <InputGroup>
                            <Label>이름</Label>
                            <StyledInput value={staffinfo.name || ''} onChange={ChangeName} />
                        </InputGroup>
                        <InputGroup>
                            <Label>영문이름</Label>
                            <StyledInput value={staffinfo.english_name || ''} onChange={ChangeEnName} />
                        </InputGroup>
                        <InputGroup>
                            <Label>연락처</Label>
                            <StyledInput value={staffinfo.phone_num || ''} onChange={ChangePhoneNum} />
                        </InputGroup>
                        <InputGroup>
                            <Label>주민등록번호</Label>
                            <StyledInput value={staffinfo.resident_number || ''} onChange={ChangeResident} />
                        </InputGroup>
                    </div>

                    <InputGroup>
                        <Label>주소</Label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledInput value={staffinfo.address || ''} onChange={ChangeAddress} style={{ flex: 1 }} />
                            <OutlineButton onClick={() => setAddressModalOpen(true)} style={{ whiteSpace: 'nowrap' }}>주소 검색</OutlineButton>
                        </div>
                    </InputGroup>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>입사일</Label>
                            <StyledInput
                                type="date"
                                value={staffinfo.regist_date || ''}
                                onChange={ChangeDate}
                            />
                        </InputGroup>
                        <InputGroup>
                            <Label>CS등급</Label>
                            <StyledSelect value={staffinfo.rank || '사원'} onChange={ChangeRank}>
                                <option value="사원">사원</option>
                                <option value="주임">주임</option>
                                <option value="대리">대리</option>
                                <option value="과장">과장</option>
                                <option value="팀장">팀장</option>
                                <option value="차장">차장</option>
                                <option value="부장">부장</option>
                                <option value="이사">이사</option>
                            </StyledSelect>
                        </InputGroup>
                        <InputGroup>
                            <Label>소속</Label>
                            <StyledInput value={staffinfo.affili || ''} onChange={ChangeAffliation} />
                        </InputGroup>
                    </div>
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={putCorrective}>적용</PrimaryButton>
                </DialogActions>
            </StyledDialog>

            {/* 주소 검색 모달 */}
            <StyledDialog ref={addressModalRef} onClose={() => setAddressModalOpen(false)}>
                <DialogHeader>
                    <h3>주소 검색</h3>
                    <CloseButton onClick={() => setAddressModalOpen(false)}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    {addressModalOpen && <DaumPostcode onComplete={handleAddressComplete} />}
                </DialogContent>
            </StyledDialog>

            {/* 삭제 확인 모달 (기존 로직 유지, 스타일 유지) */}
            {isDeleteModalOpen && staffToDelete && (
                <ConfirmationModalOverlay>
                    <ConfirmationModalContent>
                        <ModalTitle>직원 삭제 확인</ModalTitle>
                        <StaffInfo>
                            {staffToDelete.name} (ID: {staffToDelete.id})
                            <p style={{ marginTop: '10px', fontWeight: 'normal', color: '#666', fontSize: '1rem' }}>
                                해당 직원을 정말로 삭제하시겠습니까?
                            </p>
                        </StaffInfo>

                        <ButtonGroup>
                            <ActionButton className="cancel" onClick={closeDeleteDialog}>
                                취소
                            </ActionButton>
                            <ActionButton className="confirm" onClick={confirmDeleteStaff}>
                                삭제
                            </ActionButton>
                        </ButtonGroup>
                    </ConfirmationModalContent>
                </ConfirmationModalOverlay>
            )}
        </div >
    );

}

// --- Styled Components (Manager.js + Staff.js Combined) ---

// 1. 기본 버튼 및 컨테이너
const BaseButton = styled.button`
    padding: 8px 18px; 
    border-radius: 8px; 
    font-weight: 600;
    cursor: pointer; 
    transition: all 0.2s; 
    border: none; 
    font-size: 0.9rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #007bff;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white; 
    border: 1px solid #ccc; 
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    gap: 10px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
`;

// 2. 모달(Dialog) 스타일
const StyledDialog = styled.dialog`
    border: none; 
    border-radius: 16px; 
    padding: 0;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px; 
    border-bottom: 1px solid #eee;
    display: flex; 
    justify-content: space-between; 
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px; 
    background: #fff; 
    max-height: 80vh; 
    overflow-y: auto;
    display: flex; 
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px; 
    border-top: 1px solid #eee;
    display: flex; 
    justify-content: flex-end; 
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; 
    border: none; 
    font-size: 1.8rem; 
    cursor: pointer; 
    color: #999; 
    line-height: 1;
    &:hover { color: #333; }
`;

// 3. 입력 필드 스타일
const InputGroup = styled.div`
    margin-bottom: 1rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
    font-size: 0.9rem;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const StyledSelect = styled.select`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    background-color: white;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

// 4. 페이지네이션 스타일
const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`;

// 5. 삭제 모달 스타일 (Staff.js 고유)
const ConfirmationModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1001;
`;

const ConfirmationModalContent = styled.div`
    background: white;
    padding: 30px;
    border-radius: 12px;
    width: 90%;
    max-width: 380px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
    text-align: center;
`;

const ModalTitle = styled.h2`
    color: #dc3545;
    font-size: 1.5rem;
    margin-bottom: 15px;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
`;

const StaffInfo = styled.p`
    font-weight: bold;
    color: #333;
    margin: 15px 0 25px 0;
    font-size: 1.1rem;
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 20px;
`;

const ActionButton = styled.button`
    padding: 10px 15px;
    font-size: 1rem;
    cursor: pointer;
    border: none;
    border-radius: 6px;
    transition: background-color 0.2s;
    width: 50%;
    
    &.cancel {
        background: #f1f1f1;
        color: #333;
        &:hover { background: #e0e0e0; }
    }
    
    &.confirm {
        background: #dc3545;
        color: white;
        &:hover { background: #c82333; }
    }
`;

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 40px;
    margin-bottom: 10px;
    margin-left: 5%;
    width: auto;
    max-width: 500px;
`;

const SearchInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.2s;
    
    &:focus {
        outline: none;
        border-color: #006edc;
    }
    
    &::placeholder {
        color: #999;
    }
`;

const SearchButton = styled.button`
    padding: 12px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    
    &:hover {
        background-color: #0056b3;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

export default Staff;